import React from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';

import LocalisedMessage from 'components/Common/LocalisedMessage';

import ErrorPage from 'components/Errors/ErrorPage';

const UnlicensedError = ({ titleTextId }) => <ErrorPage title="Access Not Granted" titleTextId={ titleTextId } showButton type="server">
  <LocalisedMessage id="unlicensed.content" />
</ErrorPage>;

UnlicensedError.propTypes = {
  titleTextId: PropTypes.string
};

UnlicensedError.defaultProps = {
  titleTextId: 'unlicensed.title'
};

export default injectIntl(UnlicensedError);
